/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordRequestDto } from '../models/ChangePasswordRequestDto';
import type { LoggedUserInfoDto } from '../models/LoggedUserInfoDto';
import type { LoginDto } from '../models/LoginDto';
import type { LoginResponseDto } from '../models/LoginResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * Refresh access token
     * Uses the refresh token cookie to issue a new access token. Also rotates the refresh token.
     * @returns any New access token issued
     * @throws ApiError
     */
    public static refresh(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refresh',
            errors: {
                401: `Invalid or expired refresh token`,
            },
        });
    }
    /**
     * User logout
     * Logs out the user by clearing JWT cookies and revoking the refresh token
     * @returns any OK
     * @throws ApiError
     */
    public static logout(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/logout',
        });
    }
    /**
     * User login
     * Authenticates user and returns user details. JWT token is set as HttpOnly cookie.
     * @param requestBody
     * @returns LoginResponseDto Successfully authenticated
     * @throws ApiError
     */
    public static login(
        requestBody: LoginDto,
    ): CancelablePromise<LoginResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid credentials`,
                403: `Coach account not approved`,
            },
        });
    }
    /**
     * Change password
     * Changes password for the currently logged-in user
     * @param requestBody
     * @returns any Password changed successfully
     * @throws ApiError
     */
    public static changePassword(
        requestBody: ChangePasswordRequestDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/change-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Current password is incorrect`,
            },
        });
    }
    /**
     * Get logged user info
     * Returns current user info from JWT token
     * @returns LoggedUserInfoDto OK
     * @throws ApiError
     */
    public static getLoggedUserInfo(): CancelablePromise<LoggedUserInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/getLoggedUserInfo',
        });
    }
}
